// extracted by mini-css-extract-plugin
export default {"sized":"date-picker_sized__pjJo4","small":"date-picker_small__B7Fu6","medium":"date-picker_medium__TAdJM","large":"date-picker_large__EvFru"};